import { onCreate } from "apps/web/src/components/MenuItem/Dialog/utils";
import MenuItemDialogContent from "apps/web/src/components/MenuItem/Dialog/Content";
import { MenuItemState } from "apps/web/src/components/MenuItem/reducer";
import { useSnackbar } from "apps/web/src/components/Snackbar/SnackbarContext";
import LoadingBackdrop from "apps/web/src/components/universal/LoadingBackdrop";
import { useCreateReusableMenuItemMutation, useMenuItemDialogQuery } from "apps/web/src/types";
import { useLocation, useNavigate } from "react-router-dom-v5-compat";
import { NAV_ORG_KITCHEN_MENU_ITEMS } from "./KitchenPaths";

const MenuItemCreatePage = () => {
  const { setMessage } = useSnackbar();
  const navigate = useNavigate();
  const location = useLocation();
  const { duplicatedMenuItemId, isDuplicate } = location.state || {};

  const onClose = () => {
    navigate(NAV_ORG_KITCHEN_MENU_ITEMS);
  };

  const [createReusableMenuItem, { loading: saving }] = useCreateReusableMenuItemMutation({
    onError: () => {
      setMessage("error", "Unable to create menu item");
    },
    onCompleted: () => {
      setMessage("success", "Created menu item");
      navigate(NAV_ORG_KITCHEN_MENU_ITEMS);
    },
  });

  const handleSave = (state: MenuItemState) => {
    onCreate({ state, createReusableMenuItem });
  };

  const { data, loading } = useMenuItemDialogQuery({
    variables: { menuItemId: duplicatedMenuItemId },
    skip: !duplicatedMenuItemId,
  });

  const initState: MenuItemState | undefined =
    duplicatedMenuItemId && data
      ? {
          menuItem: {
            ...data.currentMenuItem,
            name: isDuplicate ? `Copy of ${data.currentMenuItem.name}` : data.currentMenuItem.name,
          },
          maxAmount: null,
          availableForOrder: true,
          allowSpecialRequests: true,
          edited: false,
        }
      : undefined;

  const isLoading = saving || (!!duplicatedMenuItemId && (loading || !data));

  return isLoading ? (
    <LoadingBackdrop open={isLoading} onClose={onClose} />
  ) : (
    <MenuItemDialogContent
      open
      pageView
      onClose={onClose}
      onSave={handleSave}
      title="Create Menu Item"
      variant="MenuItem"
      initState={initState}
    />
  );
};

export default MenuItemCreatePage;
